// extracted by mini-css-extract-plugin
export default {"custom_form_item":"index_custom_form_item__4ogLo"};